import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { APP_CONFIG, environment, IAppConfig, IDynamicAppConfig, StaticAppConfig } from '@env';
import { AppModule } from './app/app.module';
import { CRISP_READY, crispReady$ } from './crisp/crisp-ready-listener';

Promise.all([
  fetch('/assets/app-config/app-config.json').then((response) => response.json()),
  // Inline the ITDS icon sprite into the document up front so the sprite icons'
  // same-document `<use href="#id">` resolves with no per-icon network fetch.
  // Without this, an external `<use href="sprite.svg#id">` leaves the icon boxes
  // empty until the sprite request finishes — visible while the page loads.
  fetch('assets/itds-icons/itds-icon-sprite.svg').then((response) => response.text()).catch(() => ''),
])
  .then(([dynamicAppConfig, iconSprite]: [IDynamicAppConfig, string]) => {
    // The sprite hides itself via zero size + absolute position (NOT display:none,
    // which would make browsers ignore the <mask> defs the *-filled icons rely on),
    // so injecting it as the first body child keeps it out of the layout.
    if (iconSprite) {
      document.body.insertAdjacentHTML('afterbegin', iconSprite);
    }

    if (environment.enableProdMode) {
      enableProdMode();
    }

    const appConfig: IAppConfig = {
      ...StaticAppConfig,
      ...dynamicAppConfig,
    };

    platformBrowserDynamic([
      { provide: APP_CONFIG, useValue: appConfig },
      { provide: CRISP_READY, useValue: crispReady$ },
    ])
      .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
      .catch(err => console.error('AppInitError', err));
  });
